import SpellsMobile from "./SpellsMobile";

export default SpellsMobile;
export { SpellsMobile };
